import styled from 'styled-components';

import { ContentBlock } from './';

const ModalContentBlock = styled(ContentBlock)`
  text-align: center;
  max-width: 640px !important;

  > header {
    display: block;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1.5rem;
  }

  // form {
  //   footer {
  //     justify-content: center;
  //     button {
  //       margin: 0 .5rem;
  //     }
  //   }
  // }
  form footer,
  footer {
    justify-content: center;
    button {
      margin: 0.5rem;
    }
  }
`;

export default ModalContentBlock;



// WEBPACK FOOTER //
// ./src/modules/pages/components/ModalContentBlock.js